<template>
  <v-layout align-start>
    <v-flex>
      <!-- Tabs-->
      <div v-if="TablaVisible == 1">
        <template>
          <v-form>
            <v-container grid-list-sm class="pa-4 white">
              <v-row>
                <v-col cols="12" md="12" class="py-0">
                  <v-alert type="success" class="subtitle-2" color="primary">
                    <div class="d-flex align-rigth justify-space-between">
                      <span>Captura de Fletes</span>

                      <div class="d-flex">
                        <v-tooltip v-model="showFactura" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="cargafactura()">
                              <v-icon>assignment_add</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Factura</span>
                        </v-tooltip>

                        <v-tooltip v-model="showCartaPorte" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="cargacartaporte()">
                              <v-icon>assignment_ind</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Carta Porte</span>
                        </v-tooltip>


                        <v-tooltip v-model="showcomprobantecarga" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="cargacomprobante()">
                              <v-icon>local_mall</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Comprobante de Carga</span>
                        </v-tooltip>

                        <v-tooltip v-model="showsellos" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="cargasellos()">
                              <v-icon>sell</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Sellos de Carga</span>
                        </v-tooltip>

                        <v-tooltip v-model="showincremento" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="cargaincremento()">
                              <v-icon>gas_meter</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar Incremento</span>
                        </v-tooltip>

                      </div>
                    </div>
                  </v-alert>
                </v-col>



                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fletefecha" label="Fecha del Flete" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="fletefecha" @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-select v-model="vehiculoid" :items="vehiculoselect" label="Vehiculo" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="tadid" :items="tadselect" label="Tad" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="py-0">
                  <v-select v-model="choferid" :items="choferselect" label="Chofer de la Pipa" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletelitros" label="Litros" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="complementoid" label="Complemento" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="complementofacha" label="Fecha del Pago" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="complementofacha" @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="time" label="Picker in dialog" prepend-icon="mdi-clock-time-four-outline"
                        readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-time-picker v-if="modal2" v-model="time" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(time)">
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>


                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="fletefactorpemex" :items="preciofletetipocostoselect" label="Costo Flete" outlined
                    @change="fletemaspeajesuma()"></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="fletepeaje" :items="preciofletetipocasetaselect" label="Costo Peaje" outlined
                    @change="fletemaspeajesuma()"></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletemaspeaje" label="Flete y Peaje" outlined type="number"></v-text-field>
                </v-col>


                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-text-field v-model="fleteuuidfactura" label="UUID Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-text-field v-model="fleteuuidcartaporte" label="UUID Carta Porte" outlined></v-text-field>
                </v-col>



              </v-row>



              <div align="center" justify="center">
                <div class="my-2">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardar" v-if="guardarvisiblesino == 0">Guardar</v-btn>
                </div>
              </div>






            </v-container>



          </v-form>
        </template>
      </div>

      <v-app id="inspire" v-if="TablaVisible == 0">
        <v-card max-width="1200">
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6" class="py-0">
                <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fecha1" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="fecha1" :readonly="fecha1 == 1" label="Fecha de Inicio" prepend-icon="event"
                      v-bind="attrs" v-on="on" solo @click="listar()"></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha1" scrollable locale="es-es" :readonly="fecha1 == 1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal1 = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog1.save(fecha1), listar()">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="6" sm="6" md="6" class="py-0">
                <v-dialog ref="dialog" v-model="modal" :return-value.sync="fecha2" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="fecha2" :readonly="fecha2 == 1" label="Fecha Fin" prepend-icon="event"
                      v-on="on" solo></v-text-field>
                  </template>
                  <v-date-picker v-model="fecha2" scrollable locale="es-es" :readonly="fecha2 == 1">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(fecha2), listar()">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-select v-model="clientetadid" :items="clientetadselect" label="Cliente" v-on:change="listar()"
                outlined></v-select>
            </v-col>


            <v-col cols="12" sm="12" md="12" class="py-0">
              <v-text-field v-model="searchTerm" label="Buscar flete" outlined></v-text-field>
            </v-col>



          </v-container>

          <v-toolbar color="primary" dark>
            <v-btn icon @click="factorpemex">
    <v-icon>mdi-truck</v-icon>
  </v-btn>
            <v-spacer></v-spacer>

            <v-toolbar-title>Relacion de Fletes</v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- Botón Nuevo -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="mostrarNuevo()">
                  <v-icon class="mb-2">mdi-pen-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar nuevo</span>
            </v-tooltip>

            <!-- Botón Excel -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="reportefleteexcel()">
                  <v-icon class="mb-2">mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Exportar a Excel</span>
            </v-tooltip>

            <!-- Botón PDF -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="reportepdf()">
                  <v-icon class="mb-2">mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>Generar PDF</span>
            </v-tooltip>

            <!-- Botón Complemento / Actualizar -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="complemento()">
                  <v-icon class="mb-2">mdi-update</v-icon>
                </v-btn>
              </template>
              <span>Actualizar complemento</span>
            </v-tooltip>



          </v-toolbar>

          <v-list three-line>
            <template v-for="(item, index) in filteredFletes">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon size="40" class="mb-2">mdi mdi-tanker-truck</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-subtitle class="text"><span class="text--primary">Nombre:</span>
                    {{ item.clientepipanombre }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Fecha:</span>
                    {{ item.fletefecha }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Litros:</span>
                    {{ item.fletelitros }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Combustible:</span>
                    {{ item.combustiblenombre }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Procedente:</span>
                    {{ item.tadnombre }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Factura:</span>
                    {{ item.facturaid }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Carta Porte:</span>
                    {{ item.fletecartaporte }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="text"><span class="text--primary">Importe:</span>
                    {{ item.fletemaspeaje }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex flex-wrap">

                    <v-chip class="ma-1" :color="item.fletecargafactura === null ? 'red darken-4' : 'green'" dark>

                      Factura
                    </v-chip>

                    <v-chip class="ma-1" :color="item.fletecargacartaporte === null ? 'red darken-4' : 'green'" dark>
                      Carta Porte
                    </v-chip>

                    <v-chip class="ma-1" :color="item.fletecargacomprobante === null ? 'red darken-4' : 'green'" dark>
                      Comprobante
                    </v-chip>

                    <v-chip class="ma-1" :color="item.fletecargasellos === null ? 'red darken-4' : 'green'" dark>
                      Sellos
                    </v-chip>

                    <v-chip class="ma-1" :color="item.fletecargaincremento === null ? 'red darken-4' : 'green'" dark>
                      Incremento
                    </v-chip>

                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-row>
                    <v-menu bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="grey lighten-1" v-bind="attrs" v-on="on">
                          <v-icon>menu</v-icon>
                        </v-btn>
                      </template>

                      <v-list>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="ver(item)">visibility</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="editar(item)">edit</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="eliminar(item)">delete</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="abono(item)">money</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon v-if="item.fletepagadosino == 0">
                            <v-icon color="grey lighten-1" @click="pagado(item)">attach_money</v-icon>
                          </v-btn>

                          <v-btn icon v-if="item.fletepagadosino == 1">
                            <v-icon color="grey lighten-1" @click="nopagado(item)">cancel</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="whatsappweb(item)">call</v-icon>
                          </v-btn>
                        </v-list-item>

                        <v-list-item>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="cargapdfedita(item)">picture_as_pdf</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-menu>


                  </v-row>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index < fletesselect.length - 1" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-app>

      <v-dialog v-model="fleteexcel" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Reporte</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="text-center">
                <vue-excel-xlsx :data="fletesselect" :columns="fleteselectexcelcabecera"
                  :file-name="'ReporteFlete:' + new Date().toISOString()" :sheet-name="'sheetname'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn color="success" fab x-large dark>
                        <span style="font-size: 3em">
                          <i class="fas fa-file-excel" dark v-on="on"></i>
                        </span>
                      </v-btn>
                    </template>
                    <span>Reporte en Excel</span>
                  </v-tooltip>
                </vue-excel-xlsx>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargapdf" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga PDF</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">


                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filepdf" accept=".pdf" @change="handleFileUpload('filepdf')">
                </v-col>


                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardardocumento">Guardar</v-btn>
                </v-card-actions>

                <!-- Vista previa de imagen -->
                <v-col cols="12" v-if="imagenopdf === 1">
                  <v-img :src="imagePreview" aspect-ratio="16/9" contain></v-img>
                </v-col>

                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <iframe :src="pdfPreview" width="100%" style="height: 70vh; border: none;"
                    class="embed-responsive-item"></iframe>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargafactura" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga Factura</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">


                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fleteuuidfactura" label="UUID Factura" outlined></v-text-field>
                </v-col>


                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filefactura" accept=".pdf" @change="handleFileUpload('filefactura')">
                </v-col>

                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarpdf()">Guardar</v-btn>
                </v-card-actions>



                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <iframe :src="pdfPreview" width="100%" style="height: 70vh; border: none;"
                    class="embed-responsive-item"></iframe>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargacartaporte" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga Carta Porte</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fleteuuidcartaporte" label="UUID Carta Porte" outlined></v-text-field>
                </v-col>
                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filecartaporte" accept=".pdf" @change="handleFileUpload('filecartaporte')">
                </v-col>



                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarcartaporte()">Guardar</v-btn>
                </v-card-actions>



                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <iframe :src="pdfPreview" width="100%" style="height: 70vh; border: none;"
                    class="embed-responsive-item"></iframe>
                </v-col>


                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargadocumentos" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Documentos Cargados</span>
          </v-card-title>

          <template>
            <v-container>
              <v-row justify="center">
                <v-col cols="6" sm="4" md="2" class="pa-2">
                  <v-card @click="openDocument(1)"
                    class="pa-3 text-center d-flex flex-column align-center justify-center elevation-3" height="140"
                    :ripple="true">
                    <v-icon size="40" class="mb-2">mdi mdi-file-document-arrow-right-outline</v-icon>
                    <v-chip class="ma-1" :color="documentofactura ? 'green' : 'red darken-4'" dark>
                      Factura
                    </v-chip>
                  </v-card>
                </v-col>

                <v-col cols="6" sm="4" md="2" class="pa-2">
                  <v-card @click="openDocument(2)"
                    class="pa-3 text-center d-flex flex-column align-center justify-center elevation-3" height="140"
                    :ripple="true">
                    <v-icon size="40" class="mb-2">mdi mdi-file-sign</v-icon>
                    <v-chip class="ma-1" :color="documentocartaporte ? 'green' : 'red darken-4'" dark>
                      CartaPorte
                    </v-chip>

                  </v-card>
                </v-col>

                <v-col cols="6" sm="4" md="2" class="pa-2">
                  <v-card @click="openDocument(3)"
                    class="pa-3 text-center d-flex flex-column align-center justify-center elevation-3" height="140"
                    :ripple="true">
                    <v-icon size="40" class="mb-2">mdi mdi-barrel</v-icon>
                    <v-chip class="ma-1" :color="documentocarga ? 'green' : 'red darken-4'" dark>
                      Comprobante
                    </v-chip>
                  </v-card>
                </v-col>

                <v-col cols="6" sm="4" md="2" class="pa-2">
                  <v-card @click="openDocument(4)"
                    class="pa-3 text-center d-flex flex-column align-center justify-center elevation-3" height="140"
                    :ripple="true">
                    <v-icon size="40" class="mb-2">mdi mdi-ribbon</v-icon>
                    <v-chip class="ma-1" :color="documentosellos ? 'green' : 'red darken-4'" dark>
                      Sellos
                    </v-chip>
                  </v-card>
                </v-col>

                <v-col cols="6" sm="4" md="2" class="pa-2">
                  <v-card @click="openDocument(5)"
                    class="pa-3 text-center d-flex flex-column align-center justify-center elevation-3" height="140"
                    :ripple="true">
                    <v-icon size="40" class="mb-2">mdi mdi-tanker-truck</v-icon>
                    <v-chip class="ma-1" :color="documentoincremento ? 'green' : 'red darken-4'" dark>
                      Incremento
                    </v-chip>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </template>




        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargacartaporteedita" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga PDF Carta Porte Edita</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filecartaporteedita" accept=".pdf"
                    @change="handleFileUpload('filecartaporteedita')">
                </v-col>




                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardardocumentoeditacarta()">Guardar</v-btn>
                </v-card-actions>



                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <iframe :src="pdfPreview" width="100%" style="height: 70vh; border: none;"
                    class="embed-responsive-item"></iframe>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargacomprobante" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga Comprobante</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">


                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fleteuuidfactura" label="UUID Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filecomprobante" accept=".pdf" @change="handleFileUpload('filecomprobante')">
                </v-col>

                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarcomprobante()">Guardar</v-btn>
                </v-card-actions>



                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <iframe :src="pdfPreview" width="100%" style="height: 70vh; border: none;"
                    class="embed-responsive-item"></iframe>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargasellos" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga Sellos</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">


                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fleteuuidfactura" label="UUID Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="filesellos" accept="image/jpeg, image/png"
                    @change="handleFileUpload('filesellos')">
                </v-col>

                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarsellos()">Guardar</v-btn>
                </v-card-actions>

                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 2">
                    <v-img :src="imagePreview"></v-img>
                  </v-col>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcargaincremento" max-width="800px">
        <v-card>
          <v-card-title>
            <span>Carga Incremento</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">


                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-select v-model="clienteid" :items="clienteselect" label="Cliente" outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible a Cargar"
                    outlined></v-select>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="facturaid" label="Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fleteuuidfactura" label="UUID Factura" outlined></v-text-field>
                </v-col>

                <v-col cols="12" md="10" class="text-center">
                  <div>Carga el Documento</div>
                  <input type="file" ref="fileincremento" accept="image/jpeg, image/png"
                    @change="handleFileUpload('fileincremento')">
                </v-col>

                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarincremento()">Guardar</v-btn>
                </v-card-actions>

                <!-- Vista previa de PDF -->
                <v-col cols="12" v-if="imagenopdf === 2">
                  <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 2">
                    <v-img :src="imagePreview"></v-img>
                  </v-col>
                </v-col>

                <v-col cols="12" class="text-center" v-if="imagenopdf">
                  <p>
                    Antes de guardar el documento, verifique que sea el correcto.
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

      <v-dialog v-model="modalcomplemento" max-width="500px">
        <v-card>
          <v-card-title>
            <span>Datos Complemento de Pago</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">




                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="complementofacha" label="Fecha del Pago" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker v-model="complementofacha" @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="py-0">
                  <v-dialog ref="dialog" v-model="modal2" :return-value.sync="time" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="time" label="Picker in dialog" prepend-icon="mdi-clock-time-four-outline"
                        readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-time-picker v-if="modal2" v-model="time" full-width>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(time)">
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="complementoid" label="Complemento" outlined type="number"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="py-0">
                  <v-text-field v-model="fletecartaporte" label="Carta Porte" outlined type="number"></v-text-field>
                </v-col>

                <v-card-actions class="justify-center">
                  <v-btn color="secondary" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="guardarcomplemento()">Guardar</v-btn>
                </v-card-actions>




              </v-row>
            </v-container>
          </v-card-text>


        </v-card>
      </v-dialog>

    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import VueExcelXlsx from "vue-excel-xlsx";



export default {
  data() {
    return {
      guardarvisible: 0,
      TablaVisible: 0,
      fletefecha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      complementofacha: moment(this.$store.state.usuario.fecha, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      fecha1: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      fecha2: moment(new Date(), "DD/MM/YYYY").format("YYYY-MM-DD"),
      modal: false,
      modal1: false,
      menu: false,
      menu1: false,
      modal: false,
      combustibleselect: [],
      clienteid: "",
      clienteselect: [],
      tadid: "",
      tadselect: [],
      facturaid: "",
      combustibleid: "",
      fletelitros: 0,
      fletefactorpemex: 0,
      fletepeaje: 0,
      fletemaspeaje: 0,
      fletecartaporte: "",
      vehiculoid: "",
      vehiculoselect: [],
      complementoid: 0,
      searchTerm: "",
      preciofletetipocosto: "",
      preciofletetipocaseta: "",
      preciofletetipocostoselect: [],
      preciofletetipocasetaselect: [],

      options: {
        locale: "en-US",
        prefix: "$",
        suffix: "",
        length: 11,
        precision: 2,
      },

      fletesselect: [],
      guardarvisiblesino: 0,
      guardarditasino: 0,
      fleteexcel: 0,
      time: null,
      menu2: false,
      modal2: false,

      fleteselectexcelcabecera: [
        { label: "FECHA", field: "fletefecha" },
        { label: "FACTURA", field: "facturaid" },
        { label: "PRODUCTO", field: "combustiblenombre" },
        { label: "CLIENTE", field: "clientepipanombre" },
        { label: "LITROS", field: "fletelitros" },
        { label: "TAD", field: "tadnombre" },
        { label: "COSTO FLETE FACTOR PEMEX", field: "fletefactorpemex" },
        { label: "PEAJE", field: "fletepeaje" },
        { label: "FLETE Y PEAJE", field: "fletemaspeaje" },
        { label: "CARTA PORTE", field: "fletecartaporte" },
        { label: "CAPACIDAD", field: "pipacapacidad" },
        { label: "FACTOR PEMEX", field: "costo_por_capacidad" },
    

      ],

      choferid: "",
      choferselect: [],

      clientetadid: 0,
      clientetadselect: [],
      url: process.env.VUE_APP_CLOUDINARY_URL_ROOT + "api/fletes/",
      modalcargapdf: false,
      imagenopdf: 0,
      show: false,
      showFactura: false,
      showCartaPorte: false,
      showcomprobantecarga: false,
      showsellos: false,
      showincremento: false,
      modalcargafactura: false,
      modalcargacartaporte: false,
      modalcargacomprobante: false,
      modalcargasellos: false,
      modalcargaincremento: false,
      fleteuuidfactura: "",
      fleteuuidcartaporte: "",
      modalcargadocumentos: false,
      cargapdfeditaselect: [],
      modalcargacartaporteedita: false,
      cargapdfcartaporteeditaselect: [],
      file: null,
      compressedFile: null,
      documentofactura: false,
      documentocartaporte: false,
      documentocarga: false,
      documentosellos: false,
      documentoincremento: false,
      modalcomplemento: false,


    };
  },


  watch: {
    modalcargadocumentos(val) {
      if (!val) {
        // Modal se cerró
        this.$nextTick(() => {
          if (this.$refs.file) {
            this.$refs.file.value = '';
          }
          this.imagePreview = null;
          this.pdfPreview = null;
          this.imagenopdf = 0;
        });
      }
    },

    modalcargacartaporte(val) {
      if (!val) {
        // Modal se cerró
        this.$nextTick(() => {
          if (this.$refs.file) {
            this.$refs.file.value = '';
          }
          this.imagePreview = null;
          this.pdfPreview = null;
          this.imagenopdf = 0;
        });
      }
    },

    modalcargafactura(val) {
      if (!val) {
        // Modal se cerró
        this.$nextTick(() => {
          if (this.$refs.file) {
            this.$refs.file.value = '';
          }
          this.imagePreview = null;
          this.pdfPreview = null;
          this.imagenopdf = 0;
        });
      }
    },

    modalcargapdf(val) {
      if (!val) {
        // Modal se cerró
        this.$nextTick(() => {
          if (this.$refs.file) {
            this.$refs.file.value = '';
          }
          this.imagePreview = null;
          this.pdfPreview = null;
          this.imagenopdf = 0;
        });
      }
    }
  },

  computed: {
    filteredFletes() {
      const searchTerm = this.searchTerm.toLowerCase();

      return this.fletesselect
        .filter(flete => {
          return (
            flete.clientepipanombre.toLowerCase().includes(searchTerm) ||
            flete.fletefecha.toLowerCase().includes(searchTerm) ||
            flete.combustiblenombre.toLowerCase().includes(searchTerm) ||
            flete.tadnombre.toLowerCase().includes(searchTerm) ||
            String(flete.facturaid).includes(searchTerm) ||
            flete.fletecartaporte.toLowerCase().includes(searchTerm)
          );
        })
        .sort((a, b) => b.fleteid - a.fleteid); // 🔥 fleteid DESC
    }

  },


  watch: {},

  created() {
    this.selectgasolinatipo();
    this.selectcliente();
    this.selecttad();
    this.listar();
    this.selectvehiculo();
    this.selectchofer();
    this.selectfletepreciocosto();
    this.selectfletepreciocaseta();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    mostrarNuevo() {
      this.guardarvisiblesino = 0;
      this.limpiar();
      this.TablaVisible = 1;
    },

    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    cargapdf() {
      this.modalcargapdf = true;
    },

    cargapdfedita(item) {
      this.fleteid = item.fleteid;
      this.modalcargadocumentos = true;
      this.cargapdfeditaselect = item;
      this.guardarditasino = 1;

      if (item.fletecargafactura) {
        this.documentofactura = true
      }

      if (item.fletecargacartaporte) {
        this.documentocartaporte = true
      }

      if (item.fletecargacomprobante) {
        this.documentocarga = true
      }

      if (item.fletecargasellos) {
        this.documentosellos = true
      }

      if (item.fletecargaincremento) {
        this.documentoincremento = true
      }


    },

    cargapdfcartaporteedita(item) {
      this.modalcargacartaporteedita = true;
      this.cargapdfcartaporteeditaselect = item;
      this.guardarditasino = 1;
    },

    cargafactura() {
      this.modalcargafactura = true;
    },

    guardarcomplemento() {

      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      axios
        .post(
          "api/fletes/actualizacomplemento",
          {

            fletecartaporte: me.fletecartaporte,
            complementoid: me.complementoid,
            complementofacha: me.complementofacha,
            complementohora: me.time
          },
          configuracion
        )
        .then(function (response) {
          me.TablaVisible = 0;
          me.listar();
          me.$swal("Flete Actualizado con Exito");
          me.fletecartaporte = "";
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });


    },

    cargacomprobante() {
      this.modalcargacomprobante = true;
    },

    cargasellos() {
      this.modalcargasellos = true;
    },

    complemento() {
      this.modalcomplemento = true;
      this.complementoid = "";
      this.fletecartaporte = "";
    },

    cargaincremento() {
      this.modalcargaincremento = true;
    },

    cargacartaporte() {
      this.modalcargacartaporte = true;
    },

    handleFileChange(event) {
      this.error = null;
      const file = event.target.files[0];


      if (!file) {
        return;
      }


      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();


      formData.append("xml", file);

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Cargar XML",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/fletes/leerxml", formData, configuracion)
            .then(function (response) {
              const data = response.data
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(refName) {

      this.imagenopdf = 0;
      this.pdfPreview = null;
      const input = this.$refs[refName];   // ⬅ ref dinámico
      if (!input) return;

      const file = input.files[0];
      if (!file) {
        return;
      }
      if (
        !/\.pdf$/i.test(file.name) &&           // PDF
        !/\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.name) // IMÁGENES
      ) {
        input.value = null;  // limpiar correctamente
        return;
      }

      this.file = file;
      let reader = new FileReader();

      reader.onload = () => {

        // 3️⃣ ASIGNAR VARIABLES
        this.imagenopdf = 2;
        this.extencion = 2;
        this.showPreview = true;
        this.pdfPreview = reader.result;
        this.imagePreview = reader.result;

      };

      reader.readAsDataURL(file);
    },

    getColor(socioestatus) {
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 3) return "#DA0707";
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectfletepreciocosto() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/fleteprecios/listartipo/1", configuracion)
        .then(function (response) {
          listaArray = response.data.fleteprecio;
          listaArray.map(function (x) {
            me.preciofletetipocostoselect.push({
              text: x.fletepreciocosto,
              value: x.fletepreciocosto,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardardocumento() {

      if (this.file == null) {
        this.$swal("No se a Ingresado la Factura");
        return;
      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let formData = new FormData();
      formData.append("pdf", me.file);
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "La Fecha es: " + me.documentofechacarga + "<br>"
          + me.documentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/leerpdfs/leer", formData, configuracion)
            .then(function (response) {
              me.fletefecha = moment(response.data.fecha_emision).format('YYYY-MM-DD');
              me.facturaid = response.data.factura;
              me.combustibleid = response.data.combustible;
              me.choferid = response.data.chofer;
              me.fletelitros = response.data.litros;
              me.vehiculoid = response.data.pipa;
              me.clienteid = response.data.clientepipa;
              me.guardarvisiblesino = 0;
              me.TablaVisible = 1;
              me.fleteuuidfactura = response.data.uuidfactura;
              me.modalcargapdf = false;
              //me.limpiar();

            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();

              }
            });
        }
      });






    },

   

     factorpemex() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
     
        urllistar = "api/fletes/listarfactor/" + me.fecha1 + "/" + me.fecha2
            axios
        .get(urllistar, configuracion)
        .then(function (response) {
          
         
          me.$swal({
  title: 'Resumen',
  html: `
    <p>Periodo: ${response.data.fecha}</p>
    <p>Gasolina: ${Number(response.data.totalgasolina).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}</p>
    <p>Factor Pemex: ${response.data.factorgasolina}</p>
    <p>Diesel: ${Number(response.data.totaldiesel).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}</p>
    <p>Factor Pemex: ${response.data.factordiesel}</p>

    
  `,
  icon: 'success'
})
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardardocumentoedita() {

      if (this.file == null) {
        this.$swal("No se a Ingresado la Factura");
        return;
      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let formData = new FormData();
      formData.append("pdf", me.file);
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "La Fecha es: " + me.documentofechacarga + "<br>"
          + me.documentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/leerpdfs/leer", formData, configuracion)
            .then(function (response) {
              //
              me.fleteid = me.cargapdfeditaselect.fleteid;
              me.fletefecha = me.cargapdfeditaselect.fletefecha;
              me.facturaid = me.cargapdfeditaselect.facturaid;
              me.combustibleid = me.cargapdfeditaselect.combustibleid;
              me.clienteid = me.cargapdfeditaselect.clienteid;
              me.fletelitros = me.cargapdfeditaselect.fletelitros;
              me.tadid = me.cargapdfeditaselect.tadid;
              me.fletefactorpemex = me.cargapdfeditaselect.fletefactorpemex;
              me.fletepeaje = me.cargapdfeditaselect.fletepeaje;
              me.fletemaspeaje = me.cargapdfeditaselect.fletemaspeaje;
              me.fletecartaporte = me.cargapdfeditaselect.fletecartaporte;
              me.vehiculoid = me.cargapdfeditaselect.vehiculoid;
              me.choferid = me.cargapdfeditaselect.choferid;
              me.complementoid = me.cargapdfeditaselect.complementoid
              me.complementofacha = me.cargapdfeditaselect.complementofacha;
              me.time = me.cargapdfeditaselect.complementohora
              me.fleteuuidfactura = me.cargapdfeditaselect.fleteuuidfactura;
              me.fleteuuidcartaporte = me.cargapdfeditaselect.fleteuuidcartaporte
              //
              me.fletefecha = moment(response.data.fecha_emision).format('YYYY-MM-DD');
              me.facturaid = response.data.factura;
              me.combustibleid = response.data.combustible;
              //me.choferid = response.data.chofer;
              me.fletelitros = response.data.litros;
              //me.vehiculoid = response.data.pipa;
              me.clienteid = response.data.clientepipa;
              me.guardarvisiblesino = 0;
              me.TablaVisible = 1;
              me.fleteuuidfactura = response.data.uuidfactura;
              me.modalcargapdf = false;
              me.modalcargadocumentos = false;
              //me.limpiar();

            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();

              }
            });
        }
      });






    },

    guardardocumentoeditacarta() {

      if (this.file == null) {
        this.$swal("No se a Ingresado la Factura");
        return;
      }

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let formData = new FormData();
      formData.append("archivo", me.file);
      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Guardar",
        html:
          "La Fecha es: " + me.documentofechacarga + "<br>"
          + me.documentonombre,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
      }).then((result) => {
        if (result.value) {
          axios
            .post("api/leerpdfs/leerpdfbasico", formData, configuracion)
            .then(function (response) {
              //
              me.fleteid = me.cargapdfcartaporteeditaselect.fleteid;
              me.fletefecha = me.cargapdfcartaporteeditaselect.fletefecha;
              me.facturaid = me.cargapdfcartaporteeditaselect.facturaid;
              me.combustibleid = me.cargapdfcartaporteeditaselect.combustibleid;
              me.clienteid = me.cargapdfcartaporteeditaselect.clienteid;
              me.fletelitros = me.cargapdfcartaporteeditaselect.fletelitros;
              me.tadid = me.cargapdfcartaporteeditaselect.tadid;
              me.fletefactorpemex = me.cargapdfcartaporteeditaselect.fletefactorpemex;
              me.fletepeaje = me.cargapdfcartaporteeditaselect.fletepeaje;
              me.fletemaspeaje = me.cargapdfcartaporteeditaselect.fletemaspeaje;
              me.fletecartaporte = me.cargapdfcartaporteeditaselect.fletecartaporte;
              me.vehiculoid = me.cargapdfcartaporteeditaselect.vehiculoid;
              me.choferid = me.cargapdfcartaporteeditaselect.choferid;
              me.complementoid = me.cargapdfcartaporteeditaselect.complementoid
              me.complementofacha = me.cargapdfcartaporteeditaselect.complementofacha;
              me.time = me.cargapdfcartaporteeditaselect.complementohora
              me.fleteuuidfactura = me.cargapdfcartaporteeditaselect.fleteuuidfactura;
              me.fleteuuidcartaporte = me.cargapdfcartaporteeditaselect.fleteuuidcartaporte
              //
              me.fletecartaporte = response.data.folio;
              me.fleteuuidcartaporte = response.data.folio_fiscal;
              //me.fletefecha = moment(response.data.fecha_emision).format('YYYY-MM-DD');
              //me.facturaid = response.data.factura;
              //me.combustibleid = response.data.combustible;
              //me.choferid = response.data.chofer;
              //me.fletelitros = response.data.litros;
              //me.vehiculoid = response.data.pipa;
              //me.clienteid = response.data.clientepipa;
              me.guardarvisiblesino = 0;
              me.TablaVisible = 1;
              //me.fleteuuidfactura = response.data.uuidfactura;
              me.modalcargapdf = false;
              me.modalcargacartaporteedita = false;
              //me.limpiar();

            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();

              }
            });
        }
      });






    },

    guardarpdf() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();
      formData.append("facturaid", me.facturaid);
      formData.append("fecha", me.fletefecha);
      formData.append("combustibleid", me.combustibleid);
      formData.append("clientepipaid", me.clienteid);
      formData.append("fleteuuidfactura", me.fleteuuidfactura);
      formData.append("file0", me.file);



      if (me.file) {
        axios
          .post("api/fletes/guardarpdf", formData, configuracion)
          .then(function (response) {
            me.$swal("Factura Agregada");
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            if (error.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
            if (error.name == "Error") {

            }
          });
      }
    },

    guardarcartaporte() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();
      formData.append("facturaid", me.facturaid);
      formData.append("fletecartaporte", me.fletecartaporte);
      formData.append("fecha", me.fletefecha);
      formData.append("combustibleid", me.combustibleid);
      formData.append("clientepipaid", me.clienteid);
      formData.append("fleteuuidcartaporte", me.fleteuuidcartaporte);
      formData.append("file0", me.file);

      if (me.file) {
        axios
          .post("api/fletes/guardarcartaporte", formData, configuracion)
          .then(function (response) {
            me.$swal("Factura Agregada");
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            if (error.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
            if (error.name == "Error") {

            }
          });
      }












    },

    guardarcomprobante() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      let formData = new FormData();
      formData.append("fleteid", me.fleteid);
      formData.append("facturaid", me.facturaid);
      formData.append("fecha", me.fletefecha);
      formData.append("combustibleid", me.combustibleid);
      formData.append("clientepipaid", me.clienteid);
      formData.append("fleteuuidfactura", me.fleteuuidfactura);
      formData.append("file0", me.file);

      if (me.file) {
        axios
          .post("api/fletes/guardarcomprobante", formData, configuracion)
          .then(function (response) {
            me.$swal("Comprobante Agregado");
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            if (error.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
            if (error.name == "Error") {

            }
          });
      }












    },

    async guardarsellos() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // 1️⃣ Comprimir imagen
      const compressedBlob = await this.compressImage(me.file, 0.6, 1280);

      // 2️⃣ Convertir Blob → File  (ESTA ES LA PARTE QUE TE FALTABA)
      const compressedFile = this.blobToFile(
        compressedBlob,
        "foto_comprimida.jpg"
      );

      // 3️⃣ Preparar FormData
      let formData = new FormData();
      formData.append("fleteid", me.fleteid);
      formData.append("facturaid", me.facturaid);
      formData.append("fecha", me.fletefecha);
      formData.append("combustibleid", me.combustibleid);
      formData.append("clientepipaid", me.clienteid);
      formData.append("fleteuuidfactura", me.fleteuuidfactura);

      // ⬅️ AHORA SÍ ES UN FILE REAL
      formData.append("file0", compressedFile);

      // 4️⃣ Enviar a Laravel
      axios
        .post("api/fletes/guardarsellos", formData, configuracion)
        .then(function (response) {
          me.$swal("Sellos Agregado");
          me.limpiar();
          me.listar();
        })
        .catch(function (error) {
          if (error.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },


    async guardarincremento() {

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // 1️⃣ Comprimir imagen
      const compressedBlob = await this.compressImage(me.file, 0.6, 1280);

      // 2️⃣ Convertir Blob → File  (ESTA ES LA PARTE QUE TE FALTABA)
      const compressedFile = this.blobToFile(
        compressedBlob,
        "foto_comprimida.jpg"
      );

      let formData = new FormData();
      formData.append("fleteid", me.fleteid);
      formData.append("facturaid", me.facturaid);
      formData.append("fecha", me.fletefecha);
      formData.append("combustibleid", me.combustibleid);
      formData.append("clientepipaid", me.clienteid);
      formData.append("fleteuuidfactura", me.fleteuuidfactura);
      formData.append("file0", compressedFile);

      if (me.file) {
        axios
          .post("api/fletes/guardarincremento", formData, configuracion)
          .then(function (response) {
            me.$swal("Incremento Agregado");
            me.limpiar();
            me.listar();
          })
          .catch(function (error) {
            if (error.status === 401) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
            if (error.name == "Error") {

            }
          });
      }
    },

    selectfletepreciocaseta() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/fleteprecios/listartipo/2", configuracion)
        .then(function (response) {
          listaArray = response.data.fleteprecio;
          listaArray.map(function (x) {
            me.preciofletetipocasetaselect.push({
              text: x.fletepreciocosto,
              value: x.fletepreciocosto,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    guardar() {
      if (this.fletefecha == "") {
        this.$swal("No se a Especificado la Fecha");
        return;
      }

      if (this.vehiculoid == "") {
        this.$swal("No se a Especificado el Vehiculo");
        return;
      }

      if (this.clienteid == "") {
        this.$swal("No se a Especificado el Cliente");
        return;
      }

      if (this.tadid == "") {
        this.$swal("No se a Especificado el Tad");
        return;
      }

      if (this.combustibleid == "") {
        this.$swal("No se a Especificado el Combustible");
        return;
      }

      if (this.choferid == "") {
        this.$swal("No se a Especificado el Chofer");
        return;
      }

      if (this.fletelitros == "") {
        this.$swal("No se a Especificado los Litros");
        return;
      }

      if (this.facturaid == "") {
        this.$swal("No se a Especificado la Factura");
        return;
      }

      if (this.fletecartaporte == "") {
        this.$swal("No se a Especificado la Carta Porte");
        return;
      }

      if (this.fletefactorpemex == "") {
        this.$swal("No se a Especificado el Costo Flete Factor Pemex");
        return;
      }

      if (this.fletemaspeaje == "") {
        this.$swal(
          "No se a Especificado el Costo Flete Factor Pemex Mas Peaje"
        );
        return;
      }
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      // Guardar
      if (me.guardarditasino == 0) {
        axios
          .post(
            "api/fletes/crear",
            {
              fletefecha: me.fletefecha,
              facturaid: me.facturaid,
              combustibleid: me.combustibleid,
              clienteid: me.clienteid,
              fletelitros: me.fletelitros,
              tadid: me.tadid,
              fletefactorpemex: me.fletefactorpemex,
              fletepeaje: me.fletepeaje,
              fletemaspeaje: me.fletemaspeaje,
              fletecartaporte: me.fletecartaporte,
              vehiculoid: me.vehiculoid,
              choferid: me.choferid,
              complementoid: me.complementoid,
              complementofacha: me.complementofacha,
              complementohora: me.time,
              //fleteuuidfactura: me.fleteuuidfactura,
              //fleteuuidcartaporte: me.fleteuuidcartaporte
            },
            configuracion
          )
          .then(function (response) {
            me.guardarpdf();
            me.limpiar();
            me.listar();
            me.$swal("Flete Capturado con Exito");
            me.TablaVisible = 0;
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
      // Editar
      if (me.guardarditasino == 1) {
        axios
          .post(
            "api/fletes/actualizar",
            {
              fleteid: me.fleteid,
              fletefecha: me.fletefecha,
              facturaid: me.facturaid,
              combustibleid: me.combustibleid,
              clienteid: me.clienteid,
              fletelitros: me.fletelitros,
              tadid: me.tadid,
              fletefactorpemex: me.fletefactorpemex,
              fletepeaje: me.fletepeaje,
              fletemaspeaje: me.fletemaspeaje,
              fletecartaporte: me.fletecartaporte,
              vehiculoid: me.vehiculoid,
              choferid: me.choferid,
              complementoid: me.complementoid,
              complementofacha: me.complementofacha,
              complementohora: me.time,
              fleteuuidfactura: me.fleteuuidfactura,
              fleteuuidcartaporte: me.fleteuuidcartaporte
            },
            configuracion
          )
          .then(function (response) {
            me.TablaVisible = 0;
            me.limpiar();
            me.listar();
            me.$swal("Flete Actualizado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }
    },

    compressImage(file, quality = 0.6, maxWidth = 1280) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => (img.src = e.target.result);

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => resolve(blob),
            "image/jpeg",
            quality
          );
        };

        img.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    // ⚡ Convertir Blob → File
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: blob.type });
    },

    openDocument(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      // ¡IMPORTANTE! Agrega responseType: 'blob' aquí
      let configuracion = {
        headers: header,
        responseType: 'blob' // Esto le dice a Axios que espere una respuesta binaria
      };

      axios
        .post("api/fletes/verdocumentotodos", {
          fleteid: me.fleteid,
          documentobusca: item
        }, configuracion)
        .then(function (response) {
          // La respuesta es un objeto Blob
          const fileBlob = response.data;
          // El tipo de contenido viene en los headers de la respuesta
          const contentType = response.headers['content-type'];

          // Crea un URL de objeto para el Blob. Esto es un URL temporal que el navegador puede usar.
          const blobUrl = URL.createObjectURL(fileBlob);

          // Opción 1: Abrir el documento en una nueva pestaña
          // Esta es la opción más sencilla y robusta para PDFs e imágenes.
          window.open(blobUrl, '_blank');

        })
        .catch(function (error) {
          console.error("Error al obtener el documento:", error);
          // Manejo de errores específicos del backend cuando el archivo no existe
          if (error.response && error.response.data && typeof error.response.data.code !== 'undefined') {
            // Si el backend devuelve JSON de error (cuando el archivo no existe)
            const errorData = JSON.parse(new TextDecoder().decode(error.response.data)); // Decodifica el Blob de error a JSON
            if (errorData.code == 400) {
              me.$swal("La Sesión ha Expirado o el documento no se encontró: " + errorData.message);
              me.$store.dispatch("salir");
            } else {
              me.$swal("Error del servidor: " + errorData.message);
            }
          } else if (error.response) {
            // Otros errores HTTP (ej. 500 del servidor)
            me.$swal("Error al cargar el documento: " + (error.response.statusText || error.response.status));
          } else {
            // Errores de red o de otro tipo
            me.$swal("Error de red o conexión: " + error.message);
          }
        });
    },

    fletemaspeajesuma() {
      this.fletemaspeaje = (
        parseFloat(this.fletefactorpemex) + parseFloat(this.fletepeaje)
      ).toFixed(2);
    },

    selectcliente() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientepipas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.clientepipa;
          me.clientetadselect.push({
            text: "TODOS",
            value: 0,
          });
          listaArray.map(function (x) {
            me.clienteselect.push({
              text: x.clientepipanombre,
              value: x.clientepipaid,
            });
            me.clientetadselect.push({
              text: x.clientepipanombre,
              value: x.clientepipaid,
            });
          });

        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    whatsappweb(item) {
      //return "https://wa.me/52"6751100973"?text=" + this.whatsappmensaje(item);
      const phoneNumber = item.clientetelefono; // Número de teléfono con código de país
      const message = "Buenos dias, Flete " + item.clientenombre + " El Dia " + item.fletefecha + " Combustible " +
        item.combustiblenombre + " Litros: " + item.fletelitros + " Procedente de " + item.tadnombre + " Factura " + item.facturaid + " Carta Porte No "
        + item.fletecartaporte + " Chofer: " + item.chofernombre + " Pipa: " + item.vehiculoplacas + " Capacidad: " + item.vehiculocapacidad +
        ". Es un Gusto Atenderlo Att: Autotransportes de Combustible Benito S.A. de C.V.";
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    },

    selecttad() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/tads/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.tad;
          listaArray.map(function (x) {
            me.tadselect.push({
              text: x.tadnombre,
              value: x.tadid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectvehiculo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/pipas/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.pipa;
          listaArray.map(function (x) {
            me.vehiculoselect.push({
              text: x.pipanombre,
              value: x.pipaid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    selectchofer() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/choferes/listar", configuracion)
        .then(function (response) {
          listaArray = response.data.chofer;
          listaArray.map(function (x) {
            me.choferselect.push({
              text: x.chofernombre,
              value: x.choferid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    close() {
      this.TablaVisible = 0;
      this.fleteexcel = 0;
      this.modalcargapdf = false;
      this.imagenopdf = 0;
      //this.$refs.file.value = null;
      //this.$refs.fileInput.value = '';
      this.modalcargafactura = false;
      this.modalcargacartaporte = false;
      this.modalcargadocumentos = false;
      this.modalcargacartaporteedita = false;
      this.modalcargacomprobante = false;
      this.modalcargasellos = false;
      this.modalcargaincremento = false;

      this.documentofactura = false;
      this.documentocartaporte = false;
      this.documentocarga = false;
      this.documentosellos = false;
      this.documentoincremento = false;
      this.modalcomplemento = false;





      // Limpia todos los posibles inputs que existan
      ['filepdf', 'filefactura', 'filecartaporte', 'filepdfedita', 'filecartaporteedita'].forEach(r => {
        if (this.$refs[r]) this.$refs[r].value = null;
      });

    },

    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      var urllistar = "";
      if (me.clientetadid == 0) {
        urllistar = "api/fletes/listar/" + me.fecha1 + "/" + me.fecha2 + "/" + "0"
      } else {
        urllistar = "api/fletes/listar/" + me.fecha1 + "/" + me.fecha2 + "/" + me.clientetadid
      }
      axios
        .get(urllistar, configuracion)
        .then(function (response) {
          me.fletesselect = response.data.flete;
        })
        .catch(function (error) {
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    reportefleteexcel() {
      this.fleteexcel = 1;
    },


    reportepdf22() {

      window.open(
        this.url +
        "pdffletes/" +
        this.fecha1 +
        "/" +
        this.fecha2 +
        "/" +
        this.clientetadid
      );
    },


    reportepdf(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      // ¡IMPORTANTE! Agrega responseType: 'blob' aquí
      let configuracion = {
        headers: header,
        responseType: 'blob' // Esto le dice a Axios que espere una respuesta binaria
      };

      axios
        .get("api/fletes/pdffletes/" + me.fecha1 + "/" + me.fecha2 + "/" + me.clientetadid, configuracion)
        //  .get("api/fletes/pdffletes/"+me.clientetadid, configuracion)
        .then(function (response) {
          // La respuesta es un objeto Blob
          const fileBlob = response.data;
          // El tipo de contenido viene en los headers de la respuesta
          const contentType = response.headers['content-type'];

          // Crea un URL de objeto para el Blob. Esto es un URL temporal que el navegador puede usar.
          const blobUrl = URL.createObjectURL(fileBlob);

          // Opción 1: Abrir el documento en una nueva pestaña
          // Esta es la opción más sencilla y robusta para PDFs e imágenes.
          window.open(blobUrl, '_blank');

        })
        .catch(function (error) {
          console.error("Error al obtener el documento:", error);
          // Manejo de errores específicos del backend cuando el archivo no existe
          if (error.response && error.response.data && typeof error.response.data.code !== 'undefined') {
            // Si el backend devuelve JSON de error (cuando el archivo no existe)
            const errorData = JSON.parse(new TextDecoder().decode(error.response.data)); // Decodifica el Blob de error a JSON
            if (errorData.code == 400) {
              me.$swal("La Sesión ha Expirado o el documento no se encontró: " + errorData.message);
              me.$store.dispatch("salir");
            } else {
              me.$swal("Error del servidor: " + errorData.message);
            }
          } else if (error.response) {
            // Otros errores HTTP (ej. 500 del servidor)
            me.$swal("Error al cargar el documento: " + (error.response.statusText || error.response.status));
          } else {
            // Errores de red o de otro tipo
            me.$swal("Error de red o conexión: " + error.message);
          }
        });
    },

    ver(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 1;
      this.guardarditasino = 0;
      this.fletefecha = item.fletefecha;
      this.facturaid = item.facturaid;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteid;
      this.fletelitros = item.fletelitros;
      this.tadid = item.tadid;
      this.fletefactorpemex = item.fletefactorpemex;
      this.fletepeaje = item.fletepeaje;
      this.fletemaspeaje = item.fletemaspeaje;
      this.fletecartaporte = item.fletecartaporte;
      this.vehiculoid = item.vehiculoid;
      this.choferid = item.choferid;
      this.complementoid = item.complementoid
      this.complementofacha = item.complementofacha;
      this.time = item.complementohora;
      this.fleteuuidfactura = item.fleteuuidfactura;
      this.fleteuuidcartaporte = item.fleteuuidcartaporte
    },

    editar(item) {
      this.TablaVisible = 1;
      this.guardarvisiblesino = 0;
      this.guardarditasino = 1;
      this.fleteid = item.fleteid;
      this.fletefecha = item.fletefecha;
      this.facturaid = item.facturaid;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteid;
      this.fletelitros = item.fletelitros;
      this.tadid = item.tadid;
      this.fletefactorpemex = item.fletefactorpemex;
      this.fletepeaje = item.fletepeaje;
      this.fletemaspeaje = item.fletemaspeaje;
      this.fletecartaporte = item.fletecartaporte;
      this.vehiculoid = item.vehiculoid;
      this.choferid = item.choferid;
      this.complementoid = item.complementoid
      this.complementofacha = item.complementofacha;
      this.time = item.complementohora
      this.fleteuuidfactura = item.fleteuuidfactura;
      this.fleteuuidcartaporte = item.fleteuuidcartaporte
    },

    eliminar(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/eliminar/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });


    },

    pagado(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Pagar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Pagar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/fletepagadosi/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Pagado", "Se a Pagado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },

    nopagado(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Cancelar el Pago",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelar Pago",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/fletes/fletepagadono/" + item.fleteid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Cancelado", "Se a Cancelado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado el Riego Checar");
              }
            });
        }
      });
    },


    abono(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      me.$swal({
        title: "Registrar Abono",
        html: `
      <p><b>Flete:</b> ${item.fleteid}</p>
      <p><b>Factura:</b> ${item.facturaid}</p>
      <p style="color:#d32f2f;font-size:16px">
        <b>Saldo actual:</b> $${(parseFloat(item.fletemaspeaje) - parseFloat(item.fleteabono)).toFixed(2)}
      </p>
    `,
        input: "number",
        inputLabel: "Monto del abono",
        inputPlaceholder: "Ingrese el monto",
        inputAttributes: {
          min: 1,
          max: item.saldo,
          step: "0.01"
        },
        showCancelButton: true,
        confirmButtonText: "Guardar Abono",
        cancelButtonText: "Cancelar",
        inputValidator: (value) => {
          if (!value || value <= 0) {
            return "Ingrese un monto válido";
          }
          if (parseFloat(value) > parseFloat(item.saldo)) {
            return "El abono no puede ser mayor al saldo actual";
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .put(
              "api/fletes/fleteabono/" + item.fleteid,
              {
                abono: result.value
              },
              configuracion
            )
            .then(function () {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal(
                "Abono registrado",
                "El abono se guardó correctamente",
                "success"
              );
              me.close();
            })
            .catch(function (error) {
              if (error.response && error.response.status === 401) {
                me.$swal("La sesión ha expirado");
                me.$store.dispatch("salir");
              } else {
                me.$swal("Error", "No se pudo registrar el abono", "error");
              }
            });
        }
      });
    },



    limpiar() {

      (this.fletefecha = moment(
        this.$store.state.usuario.fecha,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD")),
        (this.facturaid = "");
      this.combustibleid = "";
      this.clienteid = "";
      this.fletelitros = 0;
      this.tadid = "";
      this.fletefactorpemex = 0;
      this.fletepeaje = 0;
      this.fletemaspeaje = 0;
      this.fletecartaporte = "";
      this.vehiculoid = "";
      this.choferid = "";
      this.guardarditasino = 0;
      this.complementoid = 0;
      this.time = null;
      this.menu2 = false;
      this.modal2 = false;
      this.modalcargapdf = false;
      this.file = null;
      this.imagePreview = null;
      this.magenopdf = null;
      this.imagenopdf = 0;
      //this.$refs.file.value = null;
      //this.$refs.fileInput.value = '';
      this.modalcargafactura = false;
      this.TablaVisible = 0;
      this.modalcargacartaporte = false;
      this.fleteuuidfactura = "";
      this.fleteuuidcartaporte = "";
      this.modalcargacomprobante = false;
      this.modalcargasellos = false;
      this.modalcargaincremento = false;
      //
      this.documentofactura = false;
      this.documentocartaporte = false;
      this.documentocarga = false;
      this.documentosellos = false;
      this.documentoincremento = false;

    },
  },
};
</script>
